import { Card, Skeleton, Stack } from "@mui/material";

export default function EducationSekeleton() {
  return (
    <Card className="pagelist-content" sx={{ p: "15px", height: "45vh", display: "flex", flexDirection: "column" }}>
      <Stack sx={{ mb: 2, justifyContent: "space-between", alignItems: "center", width: "100%", flexDirection: "row" }}>
        <Skeleton variant="text" width={100} height={32} />
        <Skeleton variant="rectangular" width={80} height={36} sx={{ borderRadius: "4px" }} />
      </Stack>
      <Stack sx={{ gap: 2, flexGrow: 1, overflow: "hidden" }}>
        {[1, 2, 3].map((item) => (
          <Stack sx={{ alignItems: "center", width: "100%", flexDirection: "row", gap: 2 }} key={item}>
            <Skeleton variant="rectangular" width={70} height={70} sx={{ borderRadius: "8px", flexShrink: 0 }} />
            <Stack sx={{ flexGrow: 1, gap: 0.5 }}>
              <Skeleton variant="text" width="60%" height={24} />
              <Skeleton variant="text" width="40%" height={18} />
              <Skeleton variant="text" width="30%" height={16} />
            </Stack>
          </Stack>
        ))}
      </Stack>
    </Card>
  );
}
